import { ApiType } from "@gymflow/common";
import { UserMemberProfileDTO } from "@gymflow/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { memberAsMemberQueryKeys } from "./memberAsMemberQueryKeys";

export function useMutationProfile({ api }: { api: ApiType }) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (profile: UserMemberProfileDTO) =>
      (await api.profileApi.updateProfile(profile)).data,
    onSettled: async () => {
      await queryClient.invalidateQueries({
        queryKey: memberAsMemberQueryKeys.all(),
      });
    },
  });
}
